import styled from 'styled-components';

export const StyledPagination = styled.div`
  display: flex;
`;
